import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { MyDocsModel } from '../models/upload/mydocs.model';
import { catchError, map } from 'rxjs/operators';
import { of, Observable, throwError } from 'rxjs';

import { tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';

@Injectable({
  providedIn: 'root'
})
export class MyDocsService {
  public myDocsModel = new MyDocsModel();
  private host = environment.apiUrl + "upload/mydocs";
  public loggedinUser: string = '';
  mySalesChannelSet = new Set<string>();
  opts = [];
  optsEmpEmp = [];

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
    console.log('MyDocsService login name ', this.loggedinUser);
  }

  public getSalesChannelsList(): Observable<MyDocsModel[]> {
    return this.http.get<MyDocsModel[]>(`${this.host}/getsaleschannelslist`);
  }

  public getCommPlanList(salesChannel: string): Observable<MyDocsModel[]> {
    return this.http.get<MyDocsModel[]>(`${this.host}/getcommplanlist/` + salesChannel);
  }

  public getCommPlanDescList() {
    let url = this.host + '/getcommplandesclist';
    return this.opts.length ?
      of(this.opts) :
      this.http.get<any>(url).pipe(tap(data => this.opts = data))
  }

  public updateDocs(myDocsModel: MyDocsModel[]) {
    let url = this.host + '/updatedocs';
    let body = myDocsModel ? JSON.stringify(myDocsModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public getMyDocsList() {
    let url = this.host + '/getmydocslist';
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  /** Fetch PDF base64 for a single document (list endpoints no longer include blob content). */
  public getDocContentById(id: number | string) {
    const url = `${this.host}/getdoccontent/${id}`;
    return this.http.get<MyDocsModel>(url).pipe(
      catchError(error => {
        this.logger.info(' error ==> ', error);
        return throwError('Something went wrong!');
      })
    );
  }

  public getSupDocsList(empid:string) {
    let url = this.host + '/getsupdocslist/'+empid;
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getEmpDocsList(employeeid: string) {
    let url = this.host + '/getempdocslist/' + employeeid;
    console.log(url);
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getEmployeeDocsList(employeeid: string) {
    let url = this.host + '/getemployeedocslist/' + employeeid;
    console.log(url);
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getMyDocsListBySalesChannel(saleschannel: string) {
    let url = this.host + '/getmydocslistbysaleschannel/' + saleschannel;
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public submitStatus(formData: FormData): Observable<MyDocsModel> {
    return this.http.post<MyDocsModel>(`${this.host}/submitstatus`, formData);
  }

  public createForm(docid: number,status: string): FormData {
    const formData = new FormData();
    formData.append('docid', docid.toString());
    formData.append('status', status);
    formData.append('currentUser', localStorage.getItem('CURRENT_USER_NAME_SESSION'));
    return formData;
  }

  public filterUserDocByEmp(empId: string) {
    let url = this.host + '/filteruserdocbyemp/' + empId;
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  uploadDocs(file: File, doc_name: string, doc_desc: string, comm_plan_id: string,effective_dt: Date): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    console.log("file === " + file);
    formData.append('file', file);
    formData.append('doc_name', doc_name);
    formData.append('doc_desc', doc_desc);
    formData.append('comm_plan_id', comm_plan_id);
    formData.append('effective_dt', effective_dt.toString());
    formData.append('current_user', this.loggedinUser);
    //console.log("comm_plan_id = "+comm_plan_id);

    const req = new HttpRequest('POST', `${this.host}/uploaddocs`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  public assignDocToEmployees(myDocsModel: MyDocsModel[]) {
    let url = this.host + '/assigndoctoemployees';
    let body = myDocsModel ? JSON.stringify(myDocsModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public saveDocs(myDocsModel: MyDocsModel[]) {
    let url = this.host + '/savedocs';
    let body = myDocsModel ? JSON.stringify(myDocsModel) : '';
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  uploadSingleDoc(file: File, id: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    console.log("file === " + file);
    formData.append('file', file);
    formData.append('id', id);

    const req = new HttpRequest('PUT', `${this.host}/updatesingledoc`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  public getAssignedDocsList(docid: any): Observable<MyDocsModel[]> {
    return this.http.get<MyDocsModel[]>(`${this.host}/getassigneddocslist/` + docid);
  }

  public getAssignedDocsExpandList(docid: any, comm_plan_id: number, user_type: string,effective_dt:any): Observable<MyDocsModel[]> {
    return this.http.get<MyDocsModel[]>(`${this.host}/getassigneddocsexpandlist/` + docid + '/' + comm_plan_id + '/' + user_type+ '/' + effective_dt);
  }

  public deleteEmp(id: number, employeeId: string): Observable<CustomHttpRespone> {
    return this.http.delete<CustomHttpRespone>(`${this.host}/deleteemp/` + id + '/' + employeeId);
  }

  public getExcelAssignedDocsList(doc_desc: string): Observable<MyDocsModel[]> {
    return this.http.get<MyDocsModel[]>(`${this.host}/getexcelassigneddocslist/` + doc_desc);
  }

  public getEmployees(val: string,filter: string, doc_desc: string, comPlanId: number) {
    this.optsEmpEmp = [];
    let url = this.host + '/getemployeelist/' + val + '/'+ filter + '/' + doc_desc + '/' + comPlanId;
    return this.optsEmpEmp.length ?
      of(this.optsEmpEmp) :
      this.http.get<any>(url).pipe(tap(data => this.optsEmpEmp = data))
  }

  public getUserTypesList() {
    let url = this.host + '/getusertypeslist';
    return this.http.get<MyDocsModel[]>(url)
      .pipe(
        map((data: MyDocsModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

}


